import React from 'react';
import { IconProps } from './types';

export const LiveCasinoIcon: React.FC<IconProps> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0474 2.07078C8.92205 1.776 7.76534 2.42887 7.46381 3.529L5.0724 12.2539C4.77087 13.3541 5.43869 14.4849 6.56403 14.7796L10.9526 15.9292C12.078 16.224 13.2347 15.5711 13.5362 14.471L15.9276 5.74606C16.2291 4.64594 15.5613 3.51514 14.436 3.22036L10.0474 2.07078ZM11.2912 10.3463C10.9556 10.3913 10.6426 10.2621 10.4329 10.0147L10.3831 10.184C10.3059 10.4458 10.436 10.7148 10.6736 10.7849L10.7453 10.806C10.8245 10.8293 10.8678 10.919 10.8421 11.0063C10.8164 11.0935 10.7313 11.1454 10.6521 11.122L9.2181 10.6995C9.13891 10.6761 9.09555 10.5865 9.12127 10.4992C9.14699 10.4119 9.23204 10.3601 9.31124 10.3834L9.38294 10.4045C9.62054 10.4745 9.87569 10.3191 9.95285 10.0572L10.0027 9.88799C9.69244 9.98211 9.35949 9.92091 9.10195 9.70113C8.65928 9.32387 8.60041 8.60488 8.97063 8.09847C9.42475 7.47703 10.216 7.1217 10.4475 7.02761L10.7601 6.91028C10.9995 6.82041 11.2584 6.89666 11.4109 7.10193L11.6102 7.37024C11.7539 7.5749 12.226 8.30265 12.2705 9.07088C12.3069 9.69712 11.8677 10.2693 11.2912 10.3463Z"
    ></path>
    <path d="M7.20126 2H4C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H4.9603C4.1704 14.2547 3.79855 13.1183 4.10797 11.9894L6.49938 3.26446C6.63352 2.77505 6.87919 2.34768 7.20126 2Z"></path>
  </svg>
);
